import { windowConsole } from './window';

const debugMsgHeader = 'Auryc Debug Message';
// TODO: consider using 'debug' package
function log (message, force) {
  if (__DEV__ && false) {
    windowConsole.log(genMessage(message));
  }
}

function warn (message) {
  if (__DEV__) {
    windowConsole.warn(genMessage(message));
  }
}

function error (message) {
  if (__DEV__) {
    windowConsole.error(genMessage(message));
  }
}

function critical (message) {
  if (__DEV__) {
    windowConsole.error(genMessage(message));
  }
}

function genMessage (msg) {
  return (+new Date()) + ' : ' + msg;
}

function isLiveDebug (feature = 'all') {
  return window.location.href.indexOf('#ardebug') > 0 ||
  (window.localStorage &&
    window.localStorage.getItem('ardebug') &&
    (window.localStorage.getItem('ardebug') === 'true' ||
    window.localStorage.getItem('ardebug').indexOf(feature) > -1));
}

function liveDebug () {
  if (isLiveDebug()) {
    console.group(debugMsgHeader);

    for (let i = 0; i < arguments.length; i++) {
      console.log(arguments[i]);
    }

    console.groupEnd();
  }
}

export default {
  log,
  warn,
  error,
  critical,
  isLiveDebug,
  liveDebug
};



/** WEBPACK FOOTER **
 ** ./src/utils/log.js
 **/